import { mapState } from 'vuex';
export default {
  data: function () {
    return {
      formDialog: false,
      editedItem: {},
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    buttons() {
      return [
        {
          title: this.$i18n_t('Common.create'),
          icon: 'fal fa-plus',
          action: 'addItem',
          valid: this.isIotHubManager,
        },
      ];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    initiallySelectedAccountIds() {
      return (this.$route.query.accounts || '')
        .split(',')
        .map((i) => parseInt(i.trim(), 10))
        .filter((i) => !isNaN(i));
    },
  },
  methods: {
    niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }
        return `${location.origin}${imagePath}`;
      }
      return '';
    },
    closeForm(operation) {
      this.formDialog = false;

      if (operation) {
        this.$refs.list.fetchList();
      }
    },
    addItem() {
      this.editedItem = {};
      this.formDialog = true;
    },
    editItem(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
  },
};
